import React, { useEffect } from 'react'

interface ProfilePhotoViewerProps {
  open: boolean
  profileImage?: string | null
  nickname?: string
  onClose: () => void
}

/**
 * 프로필 사진을 인스타그램처럼 확대해서 보여주는 오버레이.
 * 어두운 배경 + 가운데 원형 확대 이미지(살짝 줌인 애니메이션). 아무 곳이나 누르면 닫힘.
 */
const ProfilePhotoViewer: React.FC<ProfilePhotoViewerProps> = ({
  open,
  profileImage,
  nickname,
  onClose,
}) => {
  // 열려 있는 동안 뒤 배경 스크롤 잠금
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  if (!open) return null

  const src = profileImage || '/images/profile-placeholder-icon.png'

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black bg-opacity-80 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-[58vw] max-w-[260px] aspect-square rounded-full overflow-hidden bg-[#F1EBE4] shadow-2xl animate-zoom-in [&_img]:select-none [&_img]:[-webkit-touch-callout:none]"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={nickname || 'profile'}
          draggable={false}
          className={`w-full h-full object-cover ${
            profileImage ? '' : 'opacity-80'
          }`}
        />
      </div>
    </div>
  )
}

export default ProfilePhotoViewer
